import styled from 'styled-components';
import Item from '../Item/Item';
import {formatCurrency} from '../../shared/utility'

const ItemWrapper = styled.div`
    max-width:700px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    margin: 20px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
`
const SummaryList = styled.ul`
    font-size: 26px;
    line-height: 1.4;
    margin: 0 0 20px;
    text-align: center;
    text-transform: capitalize;
    padding:15px;
    list-style: none;
    background: #F5F7FA
`
const SummaryListItem = styled.li`
    font-size: 14px;
    line-height: 20px;
    color: #666E7F;
    text-align: center;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:10px;
    &:last-child {
        margin-bottom: 0;
    }
`
const SummaryListValue = styled.span`
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #2F3842;
    text-align: center;
    text-transform: capitalize;
`
const SummaryMessage = styled.span`
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #DF1338;
    text-align: center;
    text-transform: capitalize;
`
const OrderTotal = styled.p`
    margin:0 0 20px;
    padding: 0 15px;
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
    color: #2F3842;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: space-between;
`
const TotalPrice = styled.span`
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    color: #2F3842;
    text-transform: capitalize;
`

const Order = props => {

    const { name, address, city, orderContent, payment , shipping, subTotal } = props

    console.log(subTotal);

    let orderContentItems = orderContent.map( item => {
        return <Item key={item.id} id={item.orderId} img={ '#'+ item.imageColor} name={item.name} 
        price= {formatCurrency( ( item.priceCents / 100 ) * item.quantity )} quantity={item.quantity} />
    })

    return (
        <ItemWrapper>
            {orderContentItems}
            <SummaryList>
                    <SummaryListItem>name:
                        <SummaryListValue>
                            {name}
                        </SummaryListValue>
                    </SummaryListItem>
                    <SummaryListItem>city:
                        <SummaryListValue>
                            {city}
                        </SummaryListValue>
                    </SummaryListItem>
                    <SummaryListItem>address:
                        <SummaryListValue>
                            {address}
                        </SummaryListValue>
                    </SummaryListItem>
                    <SummaryListItem>subtotal:
                        <SummaryListValue>
                            {formatCurrency(subTotal)}
                        </SummaryListValue>
                    </SummaryListItem>
                    <SummaryListItem>shipping price:
                        <SummaryListValue>
                            {formatCurrency(shipping)}
                        </SummaryListValue>
                    </SummaryListItem>
                    <SummaryListItem>payment method:
                        <SummaryListValue>
                            {payment}
                        </SummaryListValue>
                    </SummaryListItem>
                    { shipping === 0 &&
                        <SummaryListItem>
                            <SummaryMessage>
                                shipping is free because your order is more than $100.00
                            </SummaryMessage>
                        </SummaryListItem>
                    }
            </SummaryList>
            <OrderTotal>Total to pay:<TotalPrice>{ formatCurrency( (subTotal + shipping) ) }</TotalPrice></OrderTotal>
        </ItemWrapper>
    )
}
export default Order;